import { gql, useMutation } from "@apollo/client";
import {
  ShipmentFragmentFragment,
  ShipmentFragmentFragmentDoc,
} from "@api/graphql/generated/generated-types";

const FORCE_ARRIVE_FOR_SHIPMENTS_MUTATION = gql`
  mutation ForceArriveForShipments(
    $courierId: ID!
    $shipmentArrivalOverrides: [ShipmentArrivalOverrideInput!]!
    $updatedBy: String!
  ) {
    forceArriveForShipments(
      courierId: $courierId
      shipmentArrivalOverrides: $shipmentArrivalOverrides
      updatedBy: $updatedBy
    ) {
      ...ShipmentFragment
    }
  }
  ${ShipmentFragmentFragmentDoc}
`;

export interface ForceArriveForShipmentsMutationVariables {
  courierId: string;
  shipmentArrivalOverrides: Array<{
    shipmentId: string;
    arrivalOverrides: Array<{
      taskId: string;
      arrivalOverride: number; // Unix timestamp as number
    }>;
    waitTimeUnfreeMinutesOverride?: number | null;
  }>;
  updatedBy: string;
}

export type ForceArriveForShipmentsShipment = ShipmentFragmentFragment;

export interface ForceArriveForShipmentsMutationData {
  forceArriveForShipments: ShipmentFragmentFragment[];
}

export function useForceArriveForShipmentsMutation() {
  return useMutation<
    ForceArriveForShipmentsMutationData,
    ForceArriveForShipmentsMutationVariables
  >(FORCE_ARRIVE_FOR_SHIPMENTS_MUTATION);
}
